__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "admin-panel";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("./src/hooks/index.ts", "0", () => (Promise.all([__webpack_require__.e(4341), __webpack_require__.e(4180), __webpack_require__.e(4823), __webpack_require__.e(3689), __webpack_require__.e(1394), __webpack_require__.e(1637), __webpack_require__.e(6024), __webpack_require__.e(3835)]).then(() => (() => (__webpack_require__(98366))))));
			register("./src/providers/index.ts", "0", () => (Promise.all([__webpack_require__.e(3963), __webpack_require__.e(3163), __webpack_require__.e(4823), __webpack_require__.e(3689), __webpack_require__.e(2977), __webpack_require__.e(7293)]).then(() => (() => (__webpack_require__(67293))))));
			register("./src/utils/index.ts", "0", () => (Promise.all([__webpack_require__.e(4341), __webpack_require__.e(3689), __webpack_require__.e(8192)]).then(() => (() => (__webpack_require__(8192))))));
			register("@apollo/client", "3.8.8", () => (Promise.all([__webpack_require__.e(1770), __webpack_require__.e(4256), __webpack_require__.e(4823), __webpack_require__.e(4407)]).then(() => (() => (__webpack_require__(4256))))));
			register("@datadog/browser-logs", "5.23.3", () => (Promise.all([__webpack_require__.e(202), __webpack_require__.e(9494)]).then(() => (() => (__webpack_require__(99494))))));
			register("@datadog/browser-rum", "5.23.3", () => (Promise.all([__webpack_require__.e(202), __webpack_require__.e(6649)]).then(() => (() => (__webpack_require__(56649))))));
			register("@devsbb/analytics-client", "1.9.8", () => (__webpack_require__.e(4970).then(() => (() => (__webpack_require__(94970))))));
			register("graphql", "15.9.0", () => (__webpack_require__.e(1473).then(() => (() => (__webpack_require__(21473))))));
			register("react-dom", "16.14.0", () => (Promise.all([__webpack_require__.e(7950), __webpack_require__.e(4823)]).then(() => (() => (__webpack_require__(97950))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(1688), __webpack_require__.e(4823), __webpack_require__.e(9141)]).then(() => (() => (__webpack_require__(62582))))));
			register("react", "16.14.0", () => (__webpack_require__.e(5043).then(() => (() => (__webpack_require__(65043))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(4574), __webpack_require__.e(4823), __webpack_require__.e(1286)]).then(() => (() => (__webpack_require__(94574))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};